import React, { createContext, useState } from 'react';


interface DictionaryType { [name: string]: any };

export const LocalCasheContext = createContext({
    has: (key:string):boolean => {return false},
    pop: (key:string):any => {return {}},
    push: (key:string, value:any):void => {},
    clear: ():void => {}
})
export const useLocalCasheContext = () => {
    const [casche, setCasche] = useState<DictionaryType>({});
    
    const has = (key:string) => {
        return (casche[key]);
    }
    const pop = (key:string) => {
        if (casche[key]) {
            const value = casche[key];

            delete casche[key]
            setCasche(casche);

            return value;
        } else {
            return undefined;
        }
    }
    const push = (key:string, value:any) => {
        casche[key] = value;
        setCasche(casche);
    }
    const clear = () => {
        setCasche({});
    }

    return {
        has,
        pop,
        push,
        clear
    }
}